
import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class Tooltip extends Vue {
  @Prop({ default: "top" }) readonly position!: string;

  get show(): boolean {
    return !!this.$slots?.body || !!this.$slots?.header;
  }
}
